import React from "react";
import { Link, Navigate, useParams } from "react-router-dom";
import { FiArrowRight, FiArrowUpRight, FiCheck } from "react-icons/fi";
import Frame from "../chrome/Frame";
import Meta from "../chrome/Meta";
import Invite from "../parts/Invite";
import services, { getService } from "../content/services";

const pad = (n) => String(n).padStart(2, "0");

const Capability = () => {
  const { slug } = useParams();
  const svc = getService(slug);
  if (!svc) return <Navigate to="/capabilities" replace />;

  const idx = services.findIndex((s) => s.slug === slug);
  const others = services.filter((s) => s.slug !== slug).slice(0, 3);

  return (
    <Frame>
      <Meta title={svc.title} description={svc.blurb} />

      <section className="svc-hero">
        <div className="shell">
          <div className="crumb">
            <Link to="/">Home</Link><span className="sep">/</span>
            <Link to="/capabilities">Capabilities</Link><span className="sep">/</span>
            {svc.title}
          </div>
          <span className="eyebrow">Capability {pad(idx + 1)} / {pad(services.length)}</span>
          <h1>{svc.title}</h1>
          <p className="lede">{svc.blurb}</p>
        </div>
      </section>

      <section className="band">
        <div className="shell">
          <div className="svc-body">
            <div className="prose">
              {svc.body.map((p, i) => <p key={i}>{p}</p>)}
              <div style={{ marginTop: "2.25rem" }}>
                <Link to="/contact" className="btn btn--cobalt">
                  Discuss this capability <FiArrowRight />
                </Link>
              </div>
            </div>
            <aside>
              <div className="panel">
                <h4>What's covered</h4>
                <ul className="tick">
                  {svc.covers.map((c, i) => (
                    <li key={i}><span className="m"><FiCheck /></span><span>{c}</span></li>
                  ))}
                </ul>
              </div>
            </aside>
          </div>

          <div className="also">
            <div className="section-title">
              <div className="left">
                <span className="eyebrow">Also relevant</span>
                <h2 style={{ fontSize: "1.7rem" }}>Capabilities often combined.</h2>
              </div>
            </div>
            <div className="caps">
              {others.map((s) => {
                const i = services.findIndex((x) => x.slug === s.slug);
                return (
                  <Link key={s.slug} to={`/capabilities/${s.slug}`} className="cap">
                    <div className="num">{pad(i + 1)} · CAPABILITY</div>
                    <h3>{s.title}</h3>
                    <p>{s.blurb}</p>
                    <span className="more">Read more <FiArrowUpRight /></span>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </section>

      <Invite />
    </Frame>
  );
};

export default Capability;
